const DashboardEngine = {
  initialize(rootElement, data) {
    this.root = rootElement;
    this.data = data;
    this.render(this.root.id || "appRootJSON", data.uiJson, data.context);
  },

  render(containerId, uiJson, context) {
    const container = document.getElementById(containerId);
    container.innerHTML = "";

    Object.entries(uiJson.layout).forEach(([region, comps]) => {
      const regionDiv = document.createElement("div");
      regionDiv.className = `region-${region}`;
      if (region === "center") {
        regionDiv.style.display = "flex";
        regionDiv.style.flexWrap = "wrap";
        regionDiv.style.gap = "15px";
      }
      comps.forEach(comp => {
        let moduleCtx = context;
        if (comp.type === "module" && comp.moduleContext)
          moduleCtx = comp.moduleContext;
        regionDiv.appendChild(this.renderComponent(comp, uiJson, moduleCtx, containerId));
      });
      container.appendChild(regionDiv);
    });
  },

  renderComponent(component, uiJson, context, containerId) {
    switch (component.type.toLowerCase()) {
      case "table": return this.renderTable(context, component.source);
      case "kpi": return this.renderKPI(context, component.value, component.label);
      case "button": return this.renderButton(context, component.label, uiJson.macros[component.onClick], uiJson, containerId);
      case "text": return this.renderText(component.content);
      case "expandablemenu": return this.renderExpandableMenu(component, context, uiJson, containerId);
      case "module": return this.renderModule(component, uiJson, context, containerId);
      default:
        const div = document.createElement("div");
        div.innerText = `Unknown component: ${component.type}`;
        return div;
    }
  },

  renderTable(context, source) {
      // 1️⃣ Optional: render a small top button menu above table
      const topButtons = this.renderButton_sub(context, source); 

      // 2️⃣ Resolve dataset
      const key = source.replace("${", "").replace("}", "");
      const datasetName = context[key];       // e.g., "Q1"
      const data = context.datasets?.[datasetName] || [];

      // 3️⃣ Create table
      const table = document.createElement("table");
      table.style.width = "100%";
      table.style.borderCollapse = "collapse";

      // 4️⃣ Empty state
      if (!data.length) {
          table.innerHTML = "<tr><td>No data available</td></tr>";
          return topButtons ? this.wrapWithButtons(topButtons, table) : table;
      }

      // 5️⃣ Table header
      const header = document.createElement("tr");
      Object.keys(data[0]).forEach(col => {
          const th = document.createElement("th");
          th.innerText = col;
          th.style.textAlign = "left";
          th.style.borderBottom = "1px solid #aaa";
          th.style.padding = "5px";
          header.appendChild(th);
      });

      // 6️⃣ Optional: three-dot menu for table actions
      const menuTh = document.createElement("th");
      menuTh.style.width = "30px";
      menuTh.style.textAlign = "right";
      menuTh.appendChild(this.renderButton_dots(context, datasetName));
      header.appendChild(menuTh);

      table.appendChild(header);

      // 7️⃣ Table body
      data.forEach(row => {
          const tr = document.createElement("tr");
          Object.values(row).forEach(val => {
              const td = document.createElement("td");
              td.innerText = val;
              td.style.borderBottom = "1px solid #eee";
              td.style.padding = "5px";
              tr.appendChild(td);
          });
          table.appendChild(tr);
      });

      // 8️⃣ Wrap table with top buttons if needed
      return topButtons ? this.wrapWithButtons(topButtons, table) : table;
  },


  // Helper to wrap table with button container
  wrapWithButtons(buttons, table) {
      const wrapper = document.createElement("div");
      if (buttons) wrapper.appendChild(buttons);
      wrapper.appendChild(table);
      return wrapper;
  },


    // Example sub-buttons above table
  renderButton_sub(context, source, moduleId) {
      const container = document.createElement("div");
      container.style.marginBottom = "5px";

      // Add Row button
      const addRowBtn = document.createElement("button");
      addRowBtn.innerText = "➕ Add Row";
      addRowBtn.onclick = () => {
          const key = source.replace("${", "").replace("}", "");
          const datasetName = context[key];
          const ds = context.datasets?.[datasetName];

          if (!ds) return;

          let newRow = {};
          if (ds.length > 0) {
              // Copy last row values
              const lastRow = ds[ds.length - 1];
              newRow = { ...lastRow };
          } else {
              // Empty cells based on table headers
              newRow = Object.fromEntries(Object.keys(ds[0] || { col1: "" }).map(k => [k, ""]));
          }

          ds.push(newRow);
          DashboardEngine.render(moduleId, context.uiJson, context); // re-render module
      };
      container.appendChild(addRowBtn);

      // Change Type button
      const changeTypeBtn = document.createElement("button");
      changeTypeBtn.innerText = "🔄 Change Type";
      changeTypeBtn.onclick = () => {
          alert("Change table type logic here for " + source);
      };
      container.appendChild(changeTypeBtn);

      return container;
  },



  // Three-dot menu for extra table actions
  renderButton_dots(context, datasetName) {
      const menuBtn = document.createElement("span");
      menuBtn.innerText = "⋮";
      menuBtn.style.cursor = "pointer";
      menuBtn.onclick = (e) => {
          alert("Table menu clicked: " + datasetName);
      };
      return menuBtn;
  },


  renderKPI(context, keyExpr, label) {
    const key = keyExpr.replace("${", "").replace("}", "");
    const div = document.createElement("div");
    div.className = "kpi";
    div.innerText = `${label}: ${context[key]}`;
    return div;
  },

  renderButton(context, label, macro, uiJson, containerId) {
    const btn = document.createElement("button");
    btn.innerText = label;
    btn.onclick = () => {
      macro.logic(context, uiJson, containerId);
      this.render(containerId, uiJson, context);
    };
    return btn;
  },

  renderExpandableMenu(component, context, uiJson, containerId) {
    const menu = document.createElement("div");
    const title = document.createElement("div");
    title.innerText = component.title;
    title.style.fontWeight = "bold";
    menu.appendChild(title);

    component.items.forEach(item => {
      const itemDiv = document.createElement("div");
      itemDiv.style.cursor = "pointer";
      itemDiv.style.marginLeft = "10px";
      itemDiv.innerText = item.label;
      itemDiv.onclick = () => {
        context.selectedDataset = item.dataset;
        uiJson.macros.calculateRevenue.logic(context);
        this.render(containerId, uiJson, context);
      };
      menu.appendChild(itemDiv);
    });

    return menu;
  },

  renderText(content) {
    const div = document.createElement("footer");
    div.innerText = content;
    return div;
  },

  renderModule(component, uiJson, context, containerId) {
      const moduleDiv = document.createElement("div");
      moduleDiv.className = "submodule";
      moduleDiv.style.display = "flex";
      moduleDiv.style.flex = "1 1 45%";
      moduleDiv.style.minWidth = "400px";
      moduleDiv.style.background = "white";
      moduleDiv.style.padding = "10px";
      moduleDiv.style.borderRadius = "6px";
      moduleDiv.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
      moduleDiv.id = component.id; // give div the module ID

      // render left/right regions
      Object.entries(component.layout).forEach(([region, comps]) => {
          const regionDiv = document.createElement("div");
          regionDiv.style.flex = region === "left" ? "1" : "3";
          regionDiv.style.margin = "5px";
          comps.forEach(c => regionDiv.appendChild(this.renderComponent(c, uiJson, context, containerId)));
          moduleDiv.appendChild(regionDiv);
      });

      // If container exists, append and replace old module
      if (containerId) {
          const container = document.getElementById(containerId);
          if (container) {
              const oldModule = document.getElementById(component.id);
              if (oldModule) container.replaceChild(moduleDiv, oldModule);
              else container.appendChild(moduleDiv);
          }
      }

      return moduleDiv;
  }

};

export default DashboardEngine;
